export default {"src":"/_next/static/media/britain.65b31bcd.svg","height":24,"width":48,"blurWidth":0,"blurHeight":0};